<template>
    <tr class="vue-option-rate-line">
        <td class="text-start title">{{ getOptionTitle }}
          <template v-if="option.pricePer == 'eenmalig'">(1x)</template>
          <template v-if="option.pricePer == 'per_dag'">({{ option.days }}x)</template>
          <template v-if="option.pricePer == 'per_week'">({{ roundUp(option.days / 7)}} weken)</template>
        </td>
        <td class="text-start line-height-1 information-button-wrapper">
            <button @click="handleModal" class="information-button">{{ translations.moreInformation }}</button>
        </td>
        <td class="text-end" v-if="!externalPriceObject">{{ (option.isOneOff ? option.price : option.totalPrice) | vatExcluder | currencyFormatter }}</td>
        <td class="text-end external-price font-weight-bold" v-if="externalPriceObject">{{ externalPriceObject.total_price | vatExcluder | currencyFormatter }}</td>
    </tr>
</template>

<script>
import CurrencyFormatter from "../../mixins/CurrencyFormatter";
import translations from "../../mixins/translations";
import ModalWrapper from "./ModalWrapper";

export default {
    name: "OptionRateLine",

    mixins: [CurrencyFormatter, translations],

    props: ['option', 'externalPriceObject'],

    computed: {
        getOptionTitle() {
            if (lodash.isEmpty(this.option.receiptTitle)) {
                return this.option.title;
            }

            return this.option.receiptTitle;
        }
    },

    methods: {
        roundUp(value) {
          return Math.ceil(value);
        },
        handleModal() {
            this.$modal.show(ModalWrapper, {
                props: {
                    description: `<p>${this.option.description}</p>`,
                },
                label: `${this.translations.moreInformation} ${lodash.lowerCase(this.translations.freeKilometers)}`,
                transition: 'fade',
            });
        },
    }
}
</script>
